import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const ShoppingCartIcon: FC<Props> = (props) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="cart icon">
      {/* <title>cart icon</title> */}
      <path
        d="M24.5 3.79126L22.1389 4.19991L21.0458 17.2233C20.9584 18.2858 20.0684 19.1031 19.0025 19.0997H6.61932C5.60117 19.102 4.73725 18.3528 4.59317 17.3448L3.51586 9.90057C3.39558 9.06851 3.97215 8.29662 4.80422 8.17629C4.8769 8.16607 21.7598 8.1604 21.7598 8.1604"
        stroke={props.fill || "currentColor" || "#3064C0"}
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.7671 11.6436V15.3078V11.6436Z"
        fill={props.fill || "currentColor" || "#3064C0"}
      />
      <path
        d="M12.7671 11.6436V15.3078"
        stroke={props.fill || "currentColor" || "#3064C0"}
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9349 13.478H14.5991H10.9349Z"
        fill={props.fill || "currentColor" || "#3064C0"}
      />
      <path
        d="M10.9349 13.478H14.5991"
        stroke={props.fill || "currentColor" || "#3064C0"}
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.496 23.6234V23.7612V23.6234ZM18.9374 23.6531C18.9374 23.9633 19.1891 24.2148 19.4994 24.2148C19.8097 24.2148 20.061 23.9633 20.061 23.6531C20.061 23.3427 19.8097 23.0913 19.4994 23.0913C19.1891 23.0913 18.9374 23.3427 18.9374 23.6531Z"
        fill={props.fill || "currentColor" || "#3064C0"}
      />
      <path
        d="M19.496 23.6234V23.7612M18.9374 23.6531C18.9374 23.9633 19.1891 24.2148 19.4994 24.2148C19.8097 24.2148 20.061 23.9633 20.061 23.6531C20.061 23.3427 19.8097 23.0913 19.4994 23.0913C19.1891 23.0913 18.9374 23.3427 18.9374 23.6531Z"
        stroke={props.fill || "currentColor" || "#3064C0"}
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.63555 23.6234V23.7612M6.07707 23.6531C6.07707 23.9633 6.32872 24.2148 6.63905 24.2148C6.94927 24.2148 7.20068 23.9633 7.20068 23.6531C7.20068 23.3427 6.94927 23.0913 6.63905 23.0913C6.32872 23.0913 6.07707 23.3427 6.07707 23.6531Z"
        stroke={props.fill || "currentColor" || "#3064C0"}
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ShoppingCartIcon;
